export default __webpack_public_path__ + "static/media/sueroterapia_2.19659a68.jpg";